<template>
  <div>
    <v-card>
      <div row justify-center align-center id="export" v-html="template.text" :style="inlineStyle">
      </div>
      <div class="px-3 text-xs-center">
        <v-btn color="info" @click="exportToPDF">Exportar a PDF</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
  import html2pdf from "html2pdf.js";

  export default {
    name: 'payment-proof',
    props: {
      document: {
        type: Object,
        required: true
      },
      template: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
      }
    },
    computed: {
      inlineStyle () {
        return {
          backgroundImage: `url(${this.template.background})` 
        }
      }
    },
    methods: {
      exportToPDF() {
        html2pdf(document.getElementById("export"), {
          margin: 0,
          filename: 'certificado.pdf',
          jsPDF: { format: 'letter', orientation: 'portrait' }
        });
      }
    },
  }
</script>

<style>
  #export {
    background-position: top left;
    background-size: cover;
    width: 816px;
    height: 1056px;
    padding: 170px 90px 96px 90px;
    text-align: justify;
    font-family: Calibri, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/school/services/digital_document.vue